import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Container } from 'react-bootstrap';
import Popover from '.';
import Button from '../Button';
import CircledIcon from '../CircledIcon';
import Label from '../Label';

function PopoverDemo() {
  const exampleBody = () => (
    <>
      <Label>Label without icons</Label>
      <Label leftIcon={light('circle-exclamation')}>Label with left icon</Label>
      <Label rightIcon={light('circle-question')}>Label with right icon</Label>
      <Label
        rightIcon={light('circle-question')}
        leftIcon={light('circle-exclamation')}
      >
        Label with left and right icon
      </Label>
      <Label statusDot="orange">Label with status dot</Label>
      <Label>
        <CircledIcon
          iconClassName="icon-left"
          size="icon-sm"
          icon={light('circle-exclamation')}
          tooltipText="Let's see if someone finds this tooltip :)"
        />
        Label with Circled Icon component
      </Label>
    </>
  );

  return (
    <Container>
      <Container className="mt-10">
        <h4>Popovers - Centered arrow - On Click</h4>
        <Container className="d-flex justify-content-between flex-wrap mt-10 p-0">
          <Popover placement="top" popoverBody={exampleBody()}>
            <Button>Top</Button>
          </Popover>
          <Popover placement="right" popoverBody={exampleBody()}>
            <Button>Right</Button>
          </Popover>
          <Popover placement="bottom" popoverBody={exampleBody()}>
            <Button>Bottom</Button>
          </Popover>
          <Popover placement="left" popoverBody={exampleBody()}>
            <Button>Left</Button>
          </Popover>
          <Popover placement="auto" popoverBody={exampleBody()}>
            <Button>Auto - Depends on available space</Button>
          </Popover>
        </Container>
        <h4>Popovers - Start arrow - On Hover</h4>
        <Container className="d-flex justify-content-between flex-wrap mt-10 p-0">
          <Popover
            trigger={['hover', 'focus']}
            placement="top-start"
            popoverBody={exampleBody()}
          >
            <Button>Top</Button>
          </Popover>
          <Popover
            trigger={['hover', 'focus']}
            placement="right-start"
            popoverBody={exampleBody()}
          >
            <Button>Right</Button>
          </Popover>
          <Popover
            trigger={['hover', 'focus']}
            placement="auto-start"
            popoverBody={exampleBody()}
          >
            <Button>Auto - Depends on available space</Button>
          </Popover>
          <Popover
            trigger={['hover', 'focus']}
            placement="bottom-start"
            popoverBody={exampleBody()}
          >
            <Button>Bottom</Button>
          </Popover>
          <Popover
            trigger={['hover', 'focus']}
            placement="left-start"
            popoverBody={exampleBody()}
          >
            <Button>Left</Button>
          </Popover>
        </Container>
        <h4>Popovers - End arrow - On Click</h4>
        <Container className="d-flex justify-content-between flex-wrap mt-10 p-0">
          <Popover placement="auto-end" popoverBody={exampleBody()}>
            <Button>Auto - Depends on available space</Button>
          </Popover>
          <Popover placement="top-end" popoverBody={exampleBody()}>
            <Button>Top</Button>
          </Popover>
          <Popover placement="right-end" popoverBody={exampleBody()}>
            <Button>Right</Button>
          </Popover>
          <Popover placement="bottom-end" popoverBody={exampleBody()}>
            <Button>Bottom</Button>
          </Popover>
          <Popover placement="left-end" popoverBody={exampleBody()}>
            <Button>Left</Button>
          </Popover>
        </Container>
      </Container>
    </Container>
  );
}

export default PopoverDemo;
